import * as marietta from '../../..';
import { Dialog } from '../../../core/view';
import { Fitting } from '../../item';

/**
 * 種別変更ダイアログ
 */
class FittingTypeSelection extends Dialog {
    target: marietta.webcad.item.Fitting;

    /**
     * コンストラクタ
     */
    constructor(draggable: boolean) {
      super(draggable);

      // ダイアログのコンテンツ生成
      const id = 'fittingTypeSelectionDialog';
      let title: string = '';
      // タイトル
      switch (marietta.webcad.WebCADGlobal.language) {
        case 'en': title = 'Select Fitting Type'; break;
        default: title = '建具の種類を選択してください'; break;
      }
      let contents = '<div class="dialogFittingTypeBtns">\n';
      let obj: any = objItemMenuFitting;
      // メニューの追加
      for (let i = 0; i < obj.itemMenuGroup.length; i += 1) {
        for (let j = 0; j < obj.itemMenuGroup[i].children.length; j += 1) {
          //壁などのアイテムは含めない
          if( -1 < obj.itemMenuGroup[i].children[j].id.indexOf("fit01") ) continue;
          if( -1 < obj.itemMenuGroup[i].children[j].id.indexOf("fit02") ) continue;

          const elBtn = document.createElement('button');
          elBtn.setAttribute('class', 'dialogFittingTypeBtns')
          elBtn.setAttribute('value', obj.itemMenuGroup[i].children[j].id)
          const span1 = document.createElement('span');
          span1.setAttribute('class', 'jp');
          const span2 = document.createElement('span');
          span2.setAttribute('class', 'en');

          const elImg = document.createElement('img');
          const elImgEn = document.createElement('img');
          elBtn.classList.add('itemMenuBtn');
          elImg.setAttribute('src', marietta.webcad.WebCADGlobal.webcad2Dmanager.webcad_url + obj.itemMenuGroup[i].children[j].img);
          elImg.setAttribute('alt', obj.itemMenuGroup[i].children[j].name);
          elImgEn.setAttribute('src', marietta.webcad.WebCADGlobal.webcad2Dmanager.webcad_url + obj.itemMenuGroup[i].children[j].img_en);
          elImgEn.setAttribute('alt', obj.itemMenuGroup[i].children[j].name_en);

          span1.appendChild(elImg);
          span2.appendChild(elImgEn);
          elBtn.appendChild(span1);
          elBtn.appendChild(span2);

          contents += elBtn.outerHTML;
        }
      }

      contents += '</div>';

      const footer = '';

      this.createDialog(id, title, contents, footer);

      // イベント設定
      const btns = document.querySelectorAll('.dialogFittingTypeBtns button');
      for (let i = 0, len = btns.length; i < len; i += 1) {
        btns[i].addEventListener('click', this.onSelectType);
      }
    }

    /**
     * 種類ボタンが選択された
     */
    onSelectType = (e: MouseEvent) => {
      const type: string = <string>(<HTMLButtonElement>e.currentTarget).getAttribute('value');
      marietta.webcad.view.dialog.FittingTypeSelection.changeFittingType(this.target,type);

      // パネルを閉じる
      marietta.webcad.WebCADGlobal.removeDialog();

      // 見積一覧更新
      marietta.webcad.WebCADGlobal.quotationItemList.createData(true);
    }

  /**
   * 建具種類変更
   * @param target
   * @param code
   */
    static changeFittingType(target : Fitting , type : string):void{
      target.itemInfo.id = type;

      // itemInfoのコピー
      const itemInfo: marietta.webcad.collection.ItemInfoCollection = target.itemInfo.clone();
      itemInfo.id = type;

      // 名称変更
      const item = marietta.webcad.WebCADGlobal.LIBRARY_ITEMSLIST.get(itemInfo.id);
      itemInfo.text = marietta.webcad.WebCADGlobal.language === 'jp' ? item.name.substring(0, 10) : item.name_en.substring(0, 10);

      marietta.webcad.WebCADGlobal.webcad2Dmanager.isParsingObjects = true;

      // 削除
      target.deleteMe();

      marietta.webcad.WebCADGlobal.webcad2Dmanager.isParsingObjects = false;

      // 新しいアイテムの生成
      marietta.webcad.WebCADGlobal.itemManager.createItem(itemInfo);

      // ヒストリ
      marietta.webcad.WebCADGlobal.webcad2Dmanager.saveToHistory();
    }
}
export default FittingTypeSelection;
